import { memo } from "react";

import { Box, Typography } from "@mui/material";
import {
  LocationOnIcon,
  SchoolIcon,
  SettingsIcon,
  ClassIcon,
  GroupsIcon,
} from "../../../../2_ksbHub/icons/icons";

import KsbAppBar from "../../../../2_ksbHub/components/KsbAppBar";
import KsbAppToolbarContainer from "../../../../2_ksbHub/components/KsbAppToolbarContainer";
import KsbToolbarUser from "../../../../2_ksbHub/components/KsbToolbarUser";
import KsbSelector from "../../../../2_ksbHub/components/KsbSelector";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useBszFinderContext } from "../../context/bszContext";

function BSZHeader({ viewMode, setViewMode }) {
  const { isATeacher, isTeacherView } = useAppContext();
  const {
    isBszAdmin,
    myReservation,
    setShowSubjectsDialog,
    setShowSubjectAdminDialog,
    setShowClassesAdminDialog,
    setShowClassesDialog,
  } = useBszFinderContext();

  const viewOptions = [
    { id: "all", label: "Alle Räume" },
    { id: "free", label: "Freie Räume" },
    { id: "mine", label: "Mein Platz" },
  ];

  return (
    <KsbAppBar>
      <KsbAppToolbarContainer>
        <KsbToolbarUser sx={{ width: "100%", justifyContent: "space-between" }}>
          {/* ✅ LEFT SIDE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <KsbSelector
              value={viewMode}
              options={viewOptions}
              getValue={(v) => v.id}
              getLabel={(v) => v.label}
              onChange={setViewMode}
            />

            {/* {!isMobile && (
              <Typography sx={{ ml: 1, fontSize: "0.9rem" }}>
                {rooms.length} Räume
              </Typography>
            )} */}

            {myReservation && (
              <Box
                sx={{ ml: 1, display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <LocationOnIcon sx={{ color: "green", fontSize: 18 }} />
                <Typography variant="body2">{myReservation.name}</Typography>
              </Box>
            )}
          </Box>

          {/* ✅ RIGHT SIDE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isBszAdmin && !isTeacherView && (
              <KsbActionButton
                label="Fächer +"
                icon={<SettingsIcon />}
                desktopIcon={<SettingsIcon />}
                onClick={() => setShowSubjectAdminDialog(true)}
                sx={{ ml: 1 }}
              />
            )}

            {isBszAdmin && !isTeacherView && (
              <KsbActionButton
                label="Klassen +"
                icon={<ClassIcon />}
                desktopIcon={<ClassIcon />}
                onClick={() => setShowClassesAdminDialog(true)}
                sx={{ ml: 1 }}
              />
            )}

            <KsbActionButton
              label="Klassen"
              icon={<GroupsIcon />}
              desktopIcon={<GroupsIcon />}
              onClick={() => setShowClassesDialog(true)}
            />

            {isATeacher && (
              <KsbActionButton
                label="Fächer"
                icon={<SchoolIcon />}
                desktopIcon={<SchoolIcon />}
                onClick={() => setShowSubjectsDialog(true)}
              />
            )}
          </Box>
        </KsbToolbarUser>
      </KsbAppToolbarContainer>
    </KsbAppBar>
  );
}

export default memo(BSZHeader);
